module.exports = __webpack_public_path__ + "img/GNO-alt.4f9e134d.svg";